import React from 'react';

import useMobileTopMatchList from './useMobileTopMatchList';
import MobileTopMatch from '../MobileTopMatch';
import MobileHeader from '../MobileHeader';
import SportsList from '../SportsList';

const MobileTopMatchList: React.FC = () => {
    const {
        periods,
        sportIds,
        missingSportEventIds,
        activeZones,
        activePeriod,
        activeSport,
        makeHandleActivePeriod,
        makeHandleChangeActiveSport,
        slideWidth,
        containerRef,
    } = useMobileTopMatchList();

    if (!activeZones || !activePeriod) return null;

    return (
        <div ref={containerRef}>
            <MobileHeader
                periods={periods}
                activeZoneIndex={activePeriod}
                makeHandleActiveZoneIndex={makeHandleActivePeriod}
            />

            <SportsList
                activeSport={activeSport}
                sportIds={sportIds}
                makeHandleChangeActiveSport={makeHandleChangeActiveSport}
            />

            <MobileTopMatch
                missingSportEventIds={missingSportEventIds}
                zones={activeZones}
                sport={activeSport}
                slideWidth={slideWidth}
            />
        </div>
    );
};

export default React.memo(MobileTopMatchList);
